import React, { FC, ReactElement } from 'react'

export const PasswordRandomise: FC = (): ReactElement => (
    <svg x='0px' y='0px' viewBox='0 0 24 24' fill='currentColor'>
        <path
            d='M16.2,9.6h-0.7V8.1c0-1.9-1.6-3.5-3.5-3.5S8.5,6.2,8.5,8.1v1.4H7.8c-0.8,0-1.4,0.6-1.4,1.4v7c0,0.8,0.6,1.4,1.4,1.4h8.4
            c0.8,0,1.4-0.6,1.4-1.4v-7C17.6,10.2,17,9.6,16.2,9.6z M9.9,8.1c0-1.2,0.9-2.1,2.1-2.1s2.1,0.9,2.1,2.1v1.4H9.9V8.1z M16.2,18H7.8
            v-7h8.4V18z M12,15.9c0.8,0,1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4s-1.4,0.6-1.4,1.4S11.2,15.9,12,15.9z'
        />
        <path
            d='M0.9,12.4c0,1.5,0.6,2.9,1.7,3.9L0.9,18h4.2v-4.2l-1.6,1.6c-0.8-0.8-1.2-1.8-1.2-3c0-1.8,1.2-3.4,2.8-4V7
            C2.7,7.6,0.9,9.8,0.9,12.4z'
        />
        <path
            d='M23.1,7.5h-4.2v4.2l1.6-1.6c0.8,0.8,1.2,1.8,1.2,3c0,1.8-1.2,3.4-2.8,4v1.5c2.4-0.6,4.2-2.8,4.2-5.4c0-1.5-0.6-2.9-1.7-3.9
            L23.1,7.5z'
        />
    </svg>
)
